<template>
    <td>{{ item.phone_number || item.email_address ? ((item.phone_number ? (item.phone_number_prepend +  item.phone_number + ' ') : '') + (item.email_address || '')) : ('-')  }}</td>
</template>

<script>
  export default {
    name: 'PersonContactRow',
    props: {
        item: [Array, Object],
    },
  }
</script>
